<template>
    <div>
        Remove {{relatedEventName}} Reminder schedule.
    </div>
</template>

<script>
    import ReminderActionSummary from '@/modules/rules-engine/actions/reminder-action-summary';

    export default {
        name: 'remove-reminder-summary',
        extends: ReminderActionSummary,
    };
</script>
